<script lang="ts">
  import { authStore } from '../stores/auth';
  import { isAuthenticated } from '../stores/auth';

  let username = $state('');
  let password = $state('');
  let isLoading = $state(false);
  let error = $state<string | null>(null);

  // Redirect wenn bereits eingeloggt
  $effect(() => {
    if ($isAuthenticated) {
      // TODO: Navigation zu POS
    }
  });

  async function handleLogin() {
    if (!username || !password) {
      error = 'Bitte Username und Passwort eingeben';
      return;
    }

    isLoading = true;
    error = null;

    try {
      await authStore.login(username, password);
      // Erfolgreich eingeloggt - Navigation erfolgt über $effect
    } catch (err) {
      error = err instanceof Error ? err.message : 'Login fehlgeschlagen';
    } finally {
      isLoading = false;
    }
  }

  function handleKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      handleLogin();
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center bg-gray-100 px-4">
  <div class="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">ML POS System</h1>
      <p class="text-gray-600">Bitte melden Sie sich an</p>
    </div>

    {#if error}
      <div class="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
        <p class="text-red-800 text-sm">{error}</p>
      </div>
    {/if}

    <form
      onsubmit={(e) => {
        e.preventDefault();
        handleLogin();
      }}
      class="space-y-6"
    >
      <div>
        <label for="username" class="block text-sm font-medium text-gray-700 mb-2">
          Username
        </label>
        <input
          id="username"
          type="text"
          bind:value={username}
          onkeypress={handleKeyPress}
          disabled={isLoading}
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed text-gray-900 bg-white placeholder:text-gray-400"
          placeholder="Benutzername"
          autocomplete="username"
        />
      </div>

      <div>
        <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
          Passwort
        </label>
        <input
          id="password"
          type="password"
          bind:value={password}
          onkeypress={handleKeyPress}
          disabled={isLoading}
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed text-gray-900 bg-white placeholder:text-gray-400"
          placeholder="Passwort"
          autocomplete="current-password"
        />
      </div>

      <button
        type="submit"
        disabled={isLoading || !username || !password}
        class="w-full bg-primary-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
      >
        {#if isLoading}
          <span class="flex items-center justify-center">
            <svg
              class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Wird angemeldet...
          </span>
        {:else}
          Anmelden
        {/if}
      </button>
    </form>
  </div>
</div>
